export default "__VITE_ASSET__B7J6SDCc__"